export const GET_SITE_BACKUP = 'GET_SITE_BACKUP';
export const GET_SITE_BACKUP_SUCCESS = 'GET_SITE_BACKUP_SUCCESS';
export const GET_SITE_BACKUP_FAIL = 'GET_SITE_BACKUP_FAIL';

export const DELETE_SITE_BACKUP = 'DELETE_SITE_BACKUP';
export const DELETE_SITE_BACKUP_SUCCESS = 'DELETE_SITE_BACKUP_SUCCESS';
export const DELETE_SITE_BACKUP_FAIL = 'DELETE_SITE_BACKUP_FAIL';

export const ADD_SITE_BACKUP = 'ADD_SITE_BACKUP';
export const ADD_SITE_BACKUP_COMPLETE = 'ADD_SITE_BACKUP_COMPLETE';

export const DOWNLOAD_SITE_BACKUP = 'DOWNLOAD_SITE_BACKUP';
export const DOWNLOAD_SITE_BACKUP_SUCCESS = 'DOWNLOAD_SITE_BACKUP_SUCCESS';
export const DOWNLOAD_SITE_BACKUP_FAIL = 'DOWNLOAD_SITE_BACKUP_FAIL';

export const UPLOAD_SITE_BACKUP = "UPLOAD_SITE_BACKUP";
export const UPLOAD_SITE_BACKUP_COMPLETE = "UPLOAD_SITE_BACKUP_COMPLETE"